var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{ref:"loadableButton",attrs:{"icon-pack":_vm.iconPack,"id":"button-with-loading","icon":_vm.icon,"color":_vm.color,"disabled":_vm.loading}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }